// extracted by mini-css-extract-plugin
module.exports = {"title":"ApplicationModal_title__25wyD","content":"ApplicationModal_content__2HlZM","main":"ApplicationModal_main___sFnY","sidebar":"ApplicationModal_sidebar__2f3gz"};